import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { HeaderRow } from '../../../components/table/HeaderRow';
import { ExpandedCheckedNameCell } from '../../StorageManager/components/table/cells/ExpandedCheckedNameCell';
import FullPathCell from '../../StorageManager/components/table/cells/FullPathCell';
import {SizeCell} from '../../StorageManager/components/table/cells/SizeCell';
//import {PredictiveStatusCell} from '../../StorageManager/components/table/cells/PredictiveStatusCell';
import classNames from 'classnames';
import { Row } from '../../../components/table/Row';
import {StyledTable} from "../../StorageManager/components/table/TableStyled";
//import {filterDataForView} from "../../StorageManager/constants";
import DateCell from "../../../components/table/cells/DateCell";
import { getFolderItems, linkEmailToFolder, unlinkEmailFromFolder } from '../actions';
import { deleteWithApproval } from '../../StorageManager/actions';
import { prepareDataIfTooManyFiles } from '../../StorageManager/utils';
import { prepareFile } from '../../StorageManager/actions';
import { getSortedRowsBy } from '../../../utils';
import styled from 'styled-components';
import { ActionsCell } from './ActionsCell';
import LinkEmailToFolderModal from './LinkEmailToFolderModal';
import IgnoreDirConfirmModal from './IgnoreDirConfirmModal';

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;

  .not-linked-dirs-table-header {
    font-size: 16px;
    font-weight: bold;
  }
`;

const ColumnSettingsButton = styled.button`
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 5px;

  &:hover {
    background-color: #0056b3;
  }
`;

const OverlayContainer = styled.div`
  position: relative;
  display: inline-block;
  margin-left: 10px;
`;

const ColumnVisibilityOverlay = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 5px;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 15px;
  min-width: 250px;
  z-index: 1000;

  .overlay-header {
    font-weight: bold;
    margin-bottom: 12px;
    color: #495057;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 8px;
  }

  .reset-button {
    background-color: #6c757d;
    color: white;
    border: none;
    padding: 4px 8px;
    border-radius: 3px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #5a6268;
    }
  }

  .column-toggles {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .column-toggle {
    display: flex;
    align-items: center;
    gap: 8px;

    input[type="checkbox"] {
      margin: 0;

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }

    label {
      margin: 0;
      cursor: pointer;
      font-size: 14px;
      color: #495057;

      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
`;

const OverlayBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
`;

const Button = styled.button`
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  margin-top: 10px;

  &:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
  }
`;

class NotLinkedDirsTable extends Component {

  state = {
    openedFolders: {},
    childrenByFolder: {},
    visibleColumns: this.getInitialColumnVisibility(),
    showColumnOverlay: false,
    selectedRow: null,
    tableSort: {
      field: 'name',
      direction: 'asc'
    },
    linkEmailOverlay: {
      isVisible: false,
      selectedFolder: null,
      linkedEmail: null
    },
    ignoreDirOverlay: {
      isVisible: false,
      selectedFolder: null
    }
  };

  getInitialColumnVisibility() {
    const defaultColumns = {
      name: true,
      fullPath: true,
      modifiedOn: true,
      size: true,
      actions: true
    };

    try {
      const saved = localStorage.getItem('notLinkedDirsTable_columnVisibility');
      if (saved) {
        const parsed = JSON.parse(saved);
        // Merge with defaults to handle new columns
        return { ...defaultColumns, ...parsed };
      }
    } catch (error) {
      console.warn('Failed to load column visibility settings:', error);
    }

    return defaultColumns;
  }

  saveColumnVisibility(visibleColumns) {
    try {
      localStorage.setItem('notLinkedDirsTable_columnVisibility', JSON.stringify(visibleColumns));
    } catch (error) {
      console.warn('Failed to save column visibility settings:', error);
    }
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const newVisibleColumns = {
        ...prevState.visibleColumns,
        [columnKey]: !prevState.visibleColumns[columnKey]
      };

      // Prevent hiding all columns - at least one must remain visible
      const visibleCount = Object.values(newVisibleColumns).filter(Boolean).length;
      if (visibleCount === 0) {
        // Don't allow hiding the last visible column
        return prevState;
      }

      // Save to localStorage
      this.saveColumnVisibility(newVisibleColumns);

      return {
        visibleColumns: newVisibleColumns
      };
    });

    // Optional: Close overlay after a short delay for better UX
    // Uncomment the lines below if you want this behavior
    // setTimeout(() => {
    //   this.closeColumnOverlay();
    // }, 300);
  };

  handleResetColumns = () => {
    const defaultColumns = {
      name: true,
      fullPath: true,
      modifiedOn: true,
      size: true,
      actions: true
    };

    this.saveColumnVisibility(defaultColumns);
    this.setState({ visibleColumns: defaultColumns });
  };

  toggleColumnOverlay = () => {
    this.setState(prevState => ({
      showColumnOverlay: !prevState.showColumnOverlay
    }));
  };

  closeColumnOverlay = () => {
    this.setState({ showColumnOverlay: false });
  };

  handleKeyDown = (event) => {
    if (event.key === 'Escape' && this.state.showColumnOverlay) {
      this.closeColumnOverlay();
    }
  };

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  isOpenedFolder = (folder) => {
    const {openedFolders} = this.state;
    const key = this.buildFolderKey(folder);
    return openedFolders[key] === true;
  };

  closeFolder = (folder) => {
    const key = this.buildFolderKey(folder);
    this.setState(prevState => ({
      openedFolders: {
        ...prevState.openedFolders,
        [key]: false
      },
      childrenByFolder: {
        ...prevState.childrenByFolder,
        [key]: []
      }
    }));
  };

  openFolder = (folder, children) => {
    const key = this.buildFolderKey(folder);
    this.setState(prevState => ({
      openedFolders: {
        ...prevState.openedFolders,
        [key]: true
      },
      childrenByFolder: {
        ...prevState.childrenByFolder,
        [key]: children
      }
    }));
  };

  handleOpenFolderClick = (folder) => {
    const {dispatch} = this.props;
    const {fsRoots} = this.props.storageManager;
    if (this.isOpenedFolder(folder)) {
      this.closeFolder(folder);
    } else {
      dispatch(getFolderItems(folder)).then(res => {
        const children = res.data.children.map(dir => prepareFile(dir, fsRoots));
        this.openFolder(folder, children);
      });
    }
  };

  handleClickLinkEmail = (folder) => {
    const { notLinkedItems } = this.props;
    const { notLinkedEmails, associatedEmailsWithDirs } = notLinkedItems;

    // Check if folder is already linked with an email
    const findLinkedEmail = (emails, rootId, contentId) => {
      return emails.find(email =>
        email.root_id === rootId && email.content_id === contentId
      );
    };

    const linkedEmail = findLinkedEmail(notLinkedEmails || [], folder.fsRootID, folder.contentID) ||
                       findLinkedEmail(associatedEmailsWithDirs || [], folder.fsRootID, folder.contentID);

    this.setState({
      linkEmailOverlay: {
        isVisible: true,
        selectedFolder: folder,
        linkedEmail: linkedEmail || null
      }
    });
  };

  handleCloseLinkEmailOverlay = () => {
    this.setState({
      linkEmailOverlay: {
        isVisible: false,
        selectedFolder: null,
        linkedEmail: null
      }
    });
  };

  handleLinkEmailSubmit = (folder, selectedEmail) => {
    const { dispatch } = this.props;

    if (selectedEmail) {
      const messageId = selectedEmail.message_id;
      const rootId = folder.fsRootID;
      const contentId = folder.contentID;

      dispatch(linkEmailToFolder(messageId, rootId, contentId))
        .then(() => {
          // Close the overlay on success
          this.handleCloseLinkEmailOverlay();
        })
        .catch((error) => {
          // Error handling is done in the action, but we can keep the overlay open
          console.error('Failed to link email to folder:', error);
        });
    }
  };

  handleUnlinkEmail = (linkedEmail) => {
    const { dispatch } = this.props;
    dispatch(unlinkEmailFromFolder(linkedEmail.message_id))
      .then(() => {
        // Close the overlay on success
        this.handleCloseLinkEmailOverlay();
      })
      .catch((error) => {
        // Error handling is done in the action, but we can keep the overlay open
        console.error('Failed to unlink email from folder:', error);
      });;
  };

  handleClickIgnore = (folder) => {
    this.setState({
      ignoreDirOverlay: {
        isVisible: true,
        selectedFolder: folder
      }
    });
  };

  handleCloseIgnoreDirOverlay = () => {
    this.setState({
      ignoreDirOverlay: {
        isVisible: false,
        selectedFolder: null
      }
    });
  };

  handleIgnoreDirSubmit = (folder, reason) => {
    const { dispatch } = this.props;

    const isHasBarcodedContent = folder.MaxDescendantWOMemfis && folder.MaxDescendantWOMemfis.length > 0;
    dispatch(deleteWithApproval([folder], null, isHasBarcodedContent, reason))
      .then(() => {
        // Close the overlay on success
        this.handleCloseIgnoreDirOverlay();
        console.log(`Directory ignored: ${folder.name || folder.FileName}, Reason: ${reason}`);
      })
      .catch((error) => {
        // Error handling
        console.error('Failed to ignore directory:', error);
      });
  };

  handleRowClick = (row) => {
    this.setState({ selectedRow: row });
  };

  handleHeaderCellClick = (field, direction) => {
    if (field !== 'expanded') {
      this.setState({tableSort: {field, direction}});
    }
  };

  sortAltFields = {
    modifiedOn: 'modifiedOn'
  };

  buildRowKey = (row) => {
    if (row.fsRootID && row.contentID) {
      return `${row.fsRootID}--${row.contentID}`;
    }
    // Fallback for other row types
    return row.FileName || row.name || JSON.stringify(row);
  };

  headers = {
    name: {
      title: 'Name',
      className: 'name',
      component: ExpandedCheckedNameCell,
      componentArgs: {
        dispatch: this.props.dispatch,
        //getConnectDriveComponent: this.props.getConnectDriveComponent,
        getTextClassName: () => '',
        //history: this.props.history,
        //isChecked: () => false,
        isNeedToConnectDrive: () => false,
        isOpened: this.isOpenedFolder,
        //onCheck: () => {}, // this.handleChangeCheck,
        onClick: () => {}, // this.handleNameCellClick,
        onExpand: this.handleOpenFolderClick,
        allowCopy: true
      }
    },
    fullPath: {
      title: 'Full Path',
      component: FullPathCell,
      className: 'full-path',
      componentArgs: {
        onClick: () => {}, // this.handleFullPathCellClick,
        allowCopy: true
      }
    },
    modifiedOn: {
      title: 'Date Modified',
      className: 'modified',
      component: DateCell,
      componentArgs: {
        toFormat: 'M/D/YYYY hh:mm:ss A',
        defaultValue: '-'
      }
    },
    size: {
      title: 'Size',
      className: 'size',
      component: SizeCell
    },
    actions: {
      title: 'Actions',
      className: 'actions',
      component: ActionsCell,
      componentArgs: {
        onLinkEmail: this.handleClickLinkEmail,
        onIgnore: this.handleClickIgnore
      }
    }
  };

  getVisibleHeaders = (excludeActions = false) => {
    const { visibleColumns } = this.state;
    const filteredHeaders = {};

    Object.keys(this.headers).forEach(key => {
      if (visibleColumns[key] && !(excludeActions && key === 'actions')) {
        filteredHeaders[key] = this.headers[key];
      }
    });

    return filteredHeaders;
  };

  getClassForNameCell = row => {
    if (row.hasNotLinkedDestination) {
      return 'yellow';
    }
    if (row.MaxDescendantWOMemfis) {
      return row.MaxDescendantWOMemfis.length > 0 ? 'green' : 'red';
    }
    return 'red';
  };

  buildFolderKey = (folder) => {
    const {fsRootID, contentID} = folder;
    return `${fsRootID}--${contentID}`;
  };

  renderRows = (rows, emptyText, isFilteredForView, isChildLevel = false) => {
    if (!rows) {
      return null;
    }

    const {tableSort} = this.state;
    const dataForView = rows; // isFilteredForView ? rows : filterDataForView(rows, currentView)[0];
    const sortedData = getSortedRowsBy(dataForView, tableSort.field, tableSort.direction, this.sortAltFields);
    const displayedData = prepareDataIfTooManyFiles(sortedData);
    const headersToUse = this.getVisibleHeaders(isChildLevel);
    
    return (
      <Fragment>
        {displayedData.map((row, i) => (
          <Fragment key={i}>
            <Row
              headers={headersToUse}
              row={row}
              key={i}
              onRowClick={this.handleRowClick}
              getRowClassNames={r => {
                const classes = [];
                if (r.isEllipsis) {
                  classes.push('tr-ellipsis');
                }
                if (this.state.selectedRow && this.buildRowKey(r) === this.buildRowKey(this.state.selectedRow)) {
                  classes.push('row-highlighted');
                }
                classes.push(this.getClassForNameCell(r));
                return classes.length > 0 ? classes.join(' ') : undefined;
              }}
            />
            {this.isOpenedFolder(row) ? this.renderRows(this.state.childrenByFolder[this.buildFolderKey(row)], emptyText, false, true) : null}
          </Fragment>
        ))}
        {
          !displayedData.length && emptyText ? (
            <tr>
              <td className="data-table-empty" colSpan={Object.keys(headersToUse).length}>{emptyText}</td>
            </tr>
          ) : null
        }
      </Fragment>
    );
  };

  render() {
    const { notLinkedDirs, notLinkedItems } = this.props;
    const { visibleColumns, showColumnOverlay, linkEmailOverlay, ignoreDirOverlay } = this.state;
    const { notLinkedEmails } = notLinkedItems;
    //const { tableSort } = this.state;
    //const { currentView } = this.props.notLinkedItems;
    const dataForView = notLinkedDirs; // filterDataForView(notLinkedDirs, currentView)[0];
    const emptyText = 'No Files';
    //const isInfoPanelCollapsed = !isShowSummaryOfDeletion && Boolean(!checkedItems.length);

    const loading = false;

    const columnLabels = {
      name: 'Name',
      fullPath: 'Full Path',
      modifiedOn: 'Date Modified',
      size: 'Size',
      actions: 'Actions'
    };

    // Calculate if this is the last visible column
    const visibleColumnCount = Object.values(visibleColumns).filter(Boolean).length;

    return (
      <div className="not-linked-dirs-table">
        <HeaderContainer>
          <div className="not-linked-dirs-table-header">Orphaned Directories</div>
          <OverlayContainer>
            <ColumnSettingsButton onClick={this.toggleColumnOverlay}>
              <i className="fas fa-columns"></i>
              Columns
            </ColumnSettingsButton>

            {showColumnOverlay && (
              <>
                <OverlayBackdrop onClick={this.closeColumnOverlay} />
                <ColumnVisibilityOverlay>
                  <div className="overlay-header">
                    <span>Column Visibility</span>
                    <button
                      className="reset-button"
                      onClick={this.handleResetColumns}
                      title="Reset to default columns"
                    >
                      Reset
                    </button>
                  </div>
                  <div className="column-toggles">
                    {Object.keys(this.headers).map(columnKey => {
                      const isChecked = visibleColumns[columnKey];
                      const isLastVisible = isChecked && visibleColumnCount === 1;

                      return (
                        <div key={columnKey} className="column-toggle">
                          <input
                            type="checkbox"
                            id={`column-${columnKey}`}
                            checked={isChecked}
                            disabled={isLastVisible}
                            onChange={() => this.handleColumnToggle(columnKey)}
                            title={isLastVisible ? "Cannot hide the last visible column" : ""}
                          />
                          <label
                            htmlFor={`column-${columnKey}`}
                            className={isLastVisible ? 'disabled' : ''}
                          >
                            {columnLabels[columnKey] || this.headers[columnKey].title}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </ColumnVisibilityOverlay>
              </>
            )}
          </OverlayContainer>
        </HeaderContainer>

        {notLinkedDirs && notLinkedDirs.length > 0 ? (
          <StyledTable
            className={classNames({
              'storage-content-table': true,
              'table-wrapper': true,
              //'info-panel-collapsed': isInfoPanelCollapsed
            })}
            >
            <div>
              <div className="table-block">
                <table
                  className={classNames({
                    table: true,
                    //[currentView.toLowerCase()]: true,
                    'n--table': true
                  })}
                >
                  <HeaderRow headers={this.getVisibleHeaders()} sort={this.state.tableSort} onHeaderCellClick={this.handleHeaderCellClick}/>
                  <tbody>
                    {!!dataForView.length && this.renderRows(dataForView, loading ? null : emptyText, true)}
                  </tbody>
                  <caption>{!dataForView.length ? emptyText : <span>&nbsp;</span>}</caption>
                </table>
                {this.props.nextFilename && (
                  <Button
                    onClick={this.props.onLoadMoreDirs}
                    disabled={this.props.isLoadingMore}
                  >
                    {this.props.isLoadingMore ? 'Loading...' : 'Load more'}
                  </Button>
                )}
              </div>
            </div>
          </StyledTable>
        ) : (
          <p>No orphaned directories to display.</p>
        )}

        <LinkEmailToFolderModal
          isVisible={linkEmailOverlay.isVisible}
          folder={linkEmailOverlay.selectedFolder}
          emails={linkEmailOverlay.linkedEmail ? [] : notLinkedEmails}
          linkedEmail={linkEmailOverlay.linkedEmail}
          onClose={this.handleCloseLinkEmailOverlay}
          onSubmit={this.handleLinkEmailSubmit}
          onUnlink={this.handleUnlinkEmail}
        />

        <IgnoreDirConfirmModal
          isVisible={ignoreDirOverlay.isVisible}
          folder={ignoreDirOverlay.selectedFolder}
          onClose={this.handleCloseIgnoreDirOverlay}
          onSubmit={this.handleIgnoreDirSubmit}
        />
      </div>
    );
  };
}

NotLinkedDirsTable.propTypes = {
  notLinkedDirs: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        FileName: PropTypes.string.isRequired,
        // Define other properties of a directory object if it's not just a string
      }),
    ])
  ),
  nextFilename: PropTypes.string,
  isLoadingMore: PropTypes.bool,
  onLoadMoreDirs: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    storageManager: state.storageManager,
    notLinkedItems: state.notLinkedItems,
  };
};

NotLinkedDirsTable.defaultProps = {
  storageManager: PropTypes.object.isRequired,
  notLinkedDirs: [],
  nextFilename: null,
  isLoadingMore: false,
  onLoadMoreDirs: () => {},
};

export default connect(mapStateToProps)(NotLinkedDirsTable);